import {
    FISP_TV_ADMIN_HOME_PATH,
    FISP_TV_ADMIN_STORAGE_KEY,
} from "./config";

function canUseStorage() {
    return typeof window !== "undefined" && typeof window.sessionStorage !== "undefined";
}

export function isFispTvAdminAuthenticated() {
    if (!canUseStorage()) {
        return false;
    }

    return window.sessionStorage.getItem(FISP_TV_ADMIN_STORAGE_KEY) === "1";
}

export function setFispTvAdminAuthenticated() {
    if (canUseStorage()) {
        window.sessionStorage.setItem(FISP_TV_ADMIN_STORAGE_KEY, "1");
    }
}

export function logoutFispTvAdmin() {
    if (!canUseStorage()) {
        return;
    }

    window.sessionStorage.removeItem(FISP_TV_ADMIN_STORAGE_KEY);
}

export function getFispTvAdminFallbackPath() {
    return FISP_TV_ADMIN_HOME_PATH;
}